import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import { Icon, PanelSection, Tooltip } from '../../components';
import ToolSettings, { IOption } from './ToolSettings';

interface ToolboxItem {
	active?: boolean;
	name: string;
	icon: string;
	disabled?: boolean;
	onClick?: (name: string) => void;
	options?: IOption[];
}

interface AdvancedToolboxProps {
	title?: string;
	items?: ToolboxItem[];
}

const AdvancedToolbox: React.FC<AdvancedToolboxProps> = ({ title, items }) => {
	const [activeItemName, setActiveItemName] = useState(null);

	useEffect(() => {
		// see if any of the items are active from the outside
		const activeItem = items?.find((item: ToolboxItem) => item.active);
		setActiveItemName(activeItem ? activeItem.name : null);
	}, [items]);

	const activeItemOptions = items?.find((item: ToolboxItem) => item.name === activeItemName)?.options;

	return (
		<PanelSection title={title}>
			<div className="flex flex-col bg-black">
				<div className="mt-0.5 flex flex-wrap bg-primary-dark py-2">
					{items?.map((item) => {
						return (
							<Tooltip position="bottom" content={<span className="text-white">{item.name}</span>} key={item.name}>
								<div
									className="mb-2 ml-2"
									onClick={() => {
										if (item.disabled) {
											return;
										}
										setActiveItemName(item.name);
										item.onClick(item.name);
									}}
								>
									<div
										className={classnames(
											'grid h-[40px] w-[40px] place-items-center rounded-md bg-black text-primary-active  ',
											activeItemName === item.name && 'bg-primary-light text-black',
											item.disabled && 'opacity-50',
											!item.disabled && 'cursor-pointer hover:cursor-pointer hover:bg-primary-light hover:text-black',
										)}
									>
										<Icon name={item.icon} />
									</div>
								</div>
							</Tooltip>
						);
					})}
				</div>
				<div className="h-auto bg-primary-dark px-2">
					<ToolSettings options={activeItemOptions} />
				</div>
			</div>
		</PanelSection>
	);
};

export default AdvancedToolbox;
